import React from "react";

export const Cards = React.forwardRef(({
  className,
  group,
  elevated,
  level,
  padding,
  id,
  style,
  children,
  ...rest
}, ref) => {
  const classes = [
    "ta-cards",
    className,
    group && "ta-cards--group",
    padding && "ta-padding_" + padding,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div ref={ref} id={id} className={classes} style={style} data-elevated={elevated ? "true" : undefined} data-level={level || undefined} {...rest}>
      {children}
    </div>
  );
});

const Card = React.forwardRef(({
  className,
  outline,
  elevated,
  filled,
  padding,
  onClick,
  id,
  style,
  children,
  ...rest
}, ref) => {
  const derivedVariant = outline ? "outline" : filled ? "filled" : undefined;
  
  const classes = [
    "ta-card",
    className,
    padding && "ta-padding_" + padding,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      ref={ref}
      onClick={onClick}
      id={id}
      className={classes}
      style={style}
      data-variant={derivedVariant}
      data-elevated={elevated ? "true" : undefined}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Card;
